module.exports = __webpack_public_path__ + "media/images/redesign-images/home/home-friend-1-medium-3dccdb9d9d18e3247cb1afda98af6e60.jpg";